import styled, { css } from 'styled-components';
import { ShadowIconButton } from 'components/common/material-ui/custom-components';
import { animation, colorUsage, fontSize, getSpacing, lineHeight } from 'stylesheet';
var CTAContainer = styled.div.withConfig({
  displayName: "style__CTAContainer",
  componentId: "sc-1ylnz83-0"
})(["display:flex;align-items:center;cursor:", ";&:not(:first-child){margin-top:", ";}& p{", "}&:hover > p{", "}&:hover > div:last-child{", "}"], function (_ref) {
  var disabled = _ref.disabled;
  return true === disabled ? 'default' : 'pointer';
}, getSpacing(2), animation.slideOutLeft(10), animation.slideInLeft(10), animation.slideOutRight(10));
var CTAButton = styled(ShadowIconButton).withConfig({
  displayName: "style__CTAButton",
  componentId: "sc-1ylnz83-1"
})(["&:hover path{fill:", ";}"], colorUsage.iconGradientHoverForeground);
var CTAText = styled.p.withConfig({
  displayName: "style__CTAText",
  componentId: "sc-1ylnz83-2"
})(["margin-left:", ";color:", ";"], getSpacing(1), colorUsage.CTAText);
var CTATextInfo = styled.div.withConfig({
  displayName: "style__CTATextInfo",
  componentId: "sc-1ylnz83-3"
})(["", " position:absolute;left:60px;display:flex;flex-direction:column;min-width:160px;font-size:", ";line-height:", ";"], animation.slideInRight(10), fontSize.smaller, lineHeight.smaller);
var CTAIconStyle = css(["& path{fill:", ";}"], colorUsage.iconForeground);
export { CTAContainer, CTAButton, CTAText, CTATextInfo, CTAIconStyle };